<template>
  <div class="exhibitors-view">
    <div class="page-content" v-loading="loading">
      <div class="search-wrapper">
        <el-input
          :placeholder="$t('Search keywords...')"
          style="width: 500px"
          v-model="searchForm.keyword"
          class="input-with-select"
          clearable
        >
          <el-button
            style="
                  color: #fff;
                  border: unset;
                  background: #619a37;
                  border-radius: unset;
                  height: 40px;
                "
            @click="handleSearch"
            slot="append"
            icon="el-icon-search"
            >{{ $t("Search") }}</el-button
          >
        </el-input>
      </div>
      <div class="table-list">
        <div
          class="info"
          v-for="item in dataSource"
          :key="item.id"
          @click="toDetail(item)"
        >
          <div
            class="name"
            style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
          >
            {{
              $i18n.locale == "zh"
                ? `${item.exhibitorName || "/"}`
                : `${item.exhibitorNameEn || "/"}`
            }}
          </div>
          <div class="venue">{{ item.boothNumber }}</div>
        </div>
      </div>
      <el-pagination
        v-if="pagination.total > 0"
        style="text-align: center; margin-top: 44px"
        background
        layout="prev, pager, next"
        :current-page="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        @current-change="onChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getProceedingExhibitors,
  getCurrentProceedingInfo
} from "../../services/proceedingExhibitor";
import ca from "element-ui/src/locale/lang/ca";

export default {
  data() {
    return {
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      searchForm: {
        keyword: "",
        isUp: true
      },
      dataSource: [],
      loading: false
    };
  },
  mounted() {
    const isYear2025 = this.$route.query.year === "2025";
    if (isYear2025) {
      sessionStorage.setItem("exhibitorsYear", "2025");
      this.searchForm.proceedingId = "983392249515741184";
      delete this.searchForm.isUp;
      this.getList();
    } else {
      sessionStorage.removeItem("exhibitorsYear");
      this.fetchCurrent();
    }
  },
  methods: {
    async fetchCurrent() {
      try {
        this.loading = true;
        const res = await getCurrentProceedingInfo();
        console.log(res);
        this.searchForm.proceedingId = res.data;
        this.loading = false;
        this.getList();
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },
    toDetail(item) {
      this.$router.push(`/companyIntroduction?id=${item.exhibitorId}`);
    },
    handleSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const res = await getProceedingExhibitors({
          size: this.pagination.size,
          page: this.pagination.current - 1,
          ...this.searchForm
        });
        this.loading = false;
        this.dataSource = res.content;
        this.pagination.total = res.totalElements;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    onChange(val) {
      this.pagination.current = val;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.page-content {
  width: 1000px;
  margin: 60px auto;
  background: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
}
.search-wrapper {
  margin: 0 auto 30px;
  text-align: center;
}
.table-list {
  .info {
    padding: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #5d5d5d;
    transition: all 0.3s;
    .name {
      flex: 1;
    }
    .venue {
      width: 200px;
      text-align: right;
    }
    &:nth-child(2n + 1) {
      background-color: #eee;
    }
    &:hover {
      background-color: #619a37;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/exhibitors/index.vue